module.exports = __webpack_public_path__ + "static/media/tbc.04320eaf.jpg";